import {connect} from 'react-redux';

import {changeStartHour} from '../../actionCreators';

const StartHourItem = ({label, onClick}) => (
    <li onClick={onClick}>{label}</li>
);

const mapDispatchToProps = (dispatch, {value}) => ({
    onClick: () => dispatch(changeStartHour(value)),
});

export default connect(undefined, mapDispatchToProps)(StartHourItem);
